export const SEARCH_PARAM_NAME = 'search';
export const ITEMS_ON_PAGE = 10;
export const FIRST_PAGE = 1;
export const MIN_SEARCH_PHRASE_LENGTH = 3;

export const filtersInitState = {
  presentations: false,
  attachments: false,
  articles: false,
  exercises: false,
  snippets: false,
  quizzes: false,
};

export const searchResultsComponentInitState = {
  searchPhrase: '',
  error: false,
  itemsCount: 0,
  filters: filtersInitState,
  currentPage: FIRST_PAGE,
  items: [],
  counterIsLoading: false,
  resultsIsLoading: false,
};
